// @flow
import { combineReducers } from "redux";
import {
  reducer as homeReducer,
  type State as HomeState,
} from "../RebrandBlogHome/ducks";
import {
  reducer as categoryReducer,
  type State as CategoryState,
} from "../RebrandBlogCategory/ducks";
import {
  reducer as postReducer,
  type State as PostState,
} from "../RebrandBlogPost/ducks";

export type State = {
  home: HomeState,
  category: CategoryState,
  post: PostState,
};

export const reducer = combineReducers({
  home: homeReducer,
  category: categoryReducer,
  post: postReducer,
});
